import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemText, Paper, Pagination, Typography } from "@mui/material";
import { USER_ADDRESS_URL, USER_ADDRESS_BY_USER_ID_URL, COUNTRY_URL, STATE_URL } from './../../../../Constants/Constants';
import AxiosInstance from './../../../../services/AxiosInstance';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { useAlert } from "./../../../alerts/AlertContext";
import { ThemeProvider } from "../../../v2/home/theme/ThemeProvider";

function UserAddress({ editUserId, selectedUserName }) {
    const [id, setId] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [mobile1, setMobile1] = useState("");
    const [mobile2, setMobile2] = useState("");

    const [countries, setCountries] = useState([]);
    const [countryId, setCountryId] = useState("");

    const [states, setStates] = useState([]);
    const [stateId, setStateId] = useState("");
    const [city, setCity] = useState("");
    const [zip, setZip] = useState("");
    const showAlert = useAlert();


    const [address, setAddress] = useState({
        id: '',
        address1: '',
        address2: '',
        mobile1: '',
        mobile2: '',
        country: { id: '' },
        state: { id: '' },
        city: '',
        zip: '',
        user: { id: '' }
    });

    useEffect(() => {
        getAddress();
        getCountries();
    }, []);


    const getCountries = () => {

        AxiosInstance.get(COUNTRY_URL).then(response => {
            setCountries(response.data.data);
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 404) {
                    console.error('Resource not found (404)');
                    //setAddress("");
                } else {
                    console.error('Server responded with error:', error.response.status);
                }
            } else if (error.request) {
                console.error('No response from server');
            } else {
                console.error('Axios error:', error.message);
            }
        });;
    }

    const getStates = (countryId) => {

        AxiosInstance.get(`${COUNTRY_URL}/${countryId}/states`).then(response => {
            setStates(response.data.data);
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 404) {
                    console.error('Resource not found (404)');
                    //setAddress("");
                } else {
                    console.error('Server responded with error:', error.response.status);
                }
            } else if (error.request) {
                console.error('No response from server');
            } else {
                console.error('Axios error:', error.message);
            }
        });;
    }

    const getAddress = () => {

        AxiosInstance.get(USER_ADDRESS_BY_USER_ID_URL + "/" + editUserId).then(response => {
            var address = response.data.data;
            setAddress(address);
            setId(address ?.id);
            setAddress1(address.address1);
            setAddress2(address.address2);
            setMobile1(address.mobile1);
            setMobile2(address.mobile2);
            setCountryId(address ?.country ?.id);
            
            getStates(address ?.country ?.id);

            setStateId(address ?.state ?.id);
            setCity(address ?.city);
            setZip(address ?.zip);

        }).catch(error => {
            if (error.response) {
                if (error.response.status === 404) {
                    console.error('Resource not found (404)');
                    //setAddress("");
                } else {
                    console.error('Server responded with error:', error.response.status);
                }
            } else if (error.request) {
                console.error('No response from server');
            } else {
                console.error('Axios error:', error.message);
            }
        });;
    }

    const handleAddress1Change = (event) => {
        setAddress1(event.target.value);
    }
    const handleAddress2Change = (event) => {
        setAddress2(event.target.value);
    }

    const handleMobile1Change = (event) => {
        setMobile1(event.target.value);
    }
    const handleMobile2Change = (event) => {
        setMobile2(event.target.value);
    }

    const handleCountryChange = (event) => {
        setCountryId(event.target.value);
        getStates(event.target.value);
    }

    const handleStateChange = (event) => {
        setStateId(event.target.value);
    }

    const handleCityChange = (event) => {
        setCity(event.target.value);
    }

    const handleZipChange = (event) => {
        setZip(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (address ?.id !== "")
            address.id = id;

        address.address1 = address1;
        address.address2 = address2;
        address.mobile1 = mobile1;
        address.mobile2 = mobile2;
        address.country = { id: (countryId === "" ? 0 : countryId) };
        address.state = { id: (stateId === "" ? 0 : stateId) };
        address.city = city;
        address.zip = zip;
        address.user = { id: editUserId };

        AxiosInstance.post(USER_ADDRESS_URL, address)
            .then((response) => {
                setAddress(response.data);

                showAlert("Address saved successfully!", "success");
            })
            .catch((error) => {
                showAlert("Address creation failed!", "error");
                console.error(error);
            });
    }

    return (
        <ThemeProvider>
            <Box
                component="form"
                sx={{ '& .MuiTextField-root': { m: 1 } }}
                noValidate
                autoComplete="off"
            >

                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>

                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Address1"
                            label="Address1"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={address1}
                            onChange={handleAddress1Change}
                        />
                    </Grid>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Address2"
                            label="Address2"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={address2}
                            onChange={handleAddress2Change}
                        />
                    </Grid>
                </Grid>
                {/* <Grid container spacing={2} columns={16}>
                    <Grid size={8}>

                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Mobile1"
                            label="Mobile1"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={mobile1}
                            onChange={handleMobile1Change}
                        />
                    </Grid>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Mobile2"
                            label="Mobile2"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={mobile2}
                            onChange={handleMobile2Change}
                        />
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>

                        <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}>
                            <InputLabel id="demo-simple-select-standard-label">Country</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={countryId}
                                onChange={handleCountryChange}
                                label="Country"

                            >
                                <MenuItem value=""> <em>None </em> </MenuItem>
                                {countries.map((cr) => <MenuItem value={cr.id}>{cr.name}</MenuItem>)}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={8}>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}>
                            <InputLabel id="demo-simple-select-standard-label">State</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={stateId}
                                onChange={handleStateChange}
                                label="State"

                            >
                                <MenuItem value=""> <em>None </em> </MenuItem>
                                {states.map((state) => <MenuItem value={state.id}>{state.name}</MenuItem>)}

                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>

                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="City"
                            label="City"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={city}
                            onChange={handleCityChange}
                        />
                    </Grid>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Zip"
                            label="Zip"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={zip}
                            onChange={handleZipChange}
                        />
                    </Grid>
                </Grid>

                <Button type="submit" onClick={handleSubmit} variant="contained" color="primary">Save</Button>

            </Box>
        </ThemeProvider>
    );
};

export default UserAddress;
